import { isDefined } from "@clipboard-health/util-ts";
import { useWorkerProfilePicture } from "@src/appV2/Agents/api/useWorkerProfilePicture";
import { type WorkplaceCommentType } from "@src/appV2/redesign/Workplace/Review/api/useWorkplaceComments";
import { useDelayedWorkplaceReviewFlag } from "@src/appV2/redesign/Workplace/Review/useDelayedWorkplaceReviewFlag";

import { Reaction } from "../types";
import { WorkplaceReviewCommentCompactCard } from "./CompactCard";

interface WorkplaceReviewCommentCompactCardProps {
  comment: WorkplaceCommentType;
  workplaceId: string;
  onLikeChanged: (comment: WorkplaceCommentType) => void;
  onClick?: () => void;
  showEngagementActions?: boolean;
  isReadOnly?: boolean;
}

export function WorkplaceReviewCommentCompactCardContainer(
  props: WorkplaceReviewCommentCompactCardProps
) {
  const { comment, workplaceId, onLikeChanged, onClick, showEngagementActions, isReadOnly } = props;
  const {
    createdAt,
    workerInfo,
    text,
    workerReaction,
    aggregates,
    shiftPeriod,
    shiftWorkerQualification,
    patientsPerNurse,
    reviewTag,
    rating,
  } = comment.attributes;
  const { id: workerId, name: workerName } = workerInfo;

  const { useDelayedReviewUI } = useDelayedWorkplaceReviewFlag();

  const { data: profilePicture, isInitialLoading: isProfilePictureLoading } =
    useWorkerProfilePicture(String(workerId), {
      enabled: isDefined(workerId),
    });

  return (
    <WorkplaceReviewCommentCompactCard
      commentId={comment.id}
      commentText={text}
      createdAtIso={createdAt}
      totalLikes={aggregates.totalLikes}
      workerName={workerName}
      isLiked={workerReaction === Reaction.LIKE}
      profilePictureUrl={profilePicture?.distribution_url}
      isLoadingProfilePicture={isProfilePictureLoading}
      workplaceId={workplaceId}
      maxLines={8}
      shiftPeriod={shiftPeriod}
      patientsPerNurse={patientsPerNurse}
      reviewTag={reviewTag}
      shiftWorkerQualification={shiftWorkerQualification}
      rating={rating}
      useDelayedReviewLayout={useDelayedReviewUI}
      showEngagementActions={showEngagementActions}
      isReadOnly={isReadOnly}
      onClick={onClick}
      onLikeChanged={onLikeChanged}
    />
  );
}
